import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectCarteiraDocumentos, voltarParaListaComSucesso, voltarParaSelecionarComErro, voltarParaUploadComErro } from '../carteiraDocumentosSlice';
import { selectPerfilCompleto } from '../../Perfil/perfilSlice';
import { getArquivoTemp, clearArquivoTemp } from '../arquivoTemp';
import { obterUploadUrl, uploadArquivoStorage, salvarDocumento } from '../../../api/carteiraDocumentosAPI';
import ImagemInterativa from './ImagemInterativa';
import PdfInterativo from './PdfInterativo';
import styles from './PreviewImagem.module.css';

const PreviewImagem: React.FC = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    dispatch(voltarParaUploadComErro('Não foi possível abrir o documento. O arquivo pode estar com erro. Selecione outro documento e tente novamente.'));
  };
  const [uploadStatus, setUploadStatus] = useState<'idle' | 'enviando' | 'salvando'>('idle');

  const dispatch = useAppDispatch();
  const dados = useAppSelector(selectCarteiraDocumentos);
  const perfil = useAppSelector(selectPerfilCompleto);

  const handlePasswordProtected = () => {
    alert('Não é possível fazer upload de PDFs protegidos por senha.');
  };

  const confirmarInclusao = async () => {
    const arquivo = getArquivoTemp();
    if (!arquivo || !dados.tipoDocumento || !dados.cpfIntegrante) return;

    const { blob, nomeArquivo, mimeType, tamanhoBytes } = arquivo;

    setUploadStatus('enviando');
    try {
      const { url, objectKey } = await obterUploadUrl(nomeArquivo, dados.tipoDocumento);
      await uploadArquivoStorage(url, blob, nomeArquivo);
      setUploadStatus('salvando');
      const nomeUsuario = perfil?.nome || perfil?.nomeSocialApelidoPessoa || '';
      await salvarDocumento(objectKey, dados.tipoDocumento, dados.cpfIntegrante, nomeArquivo, tamanhoBytes, mimeType, nomeUsuario, dados.integranteNome || '');
      clearArquivoTemp();
      dispatch(voltarParaListaComSucesso());
    } catch (err: any) {
      const mensagem = err?.message || 'Erro ao enviar o documento. Tente novamente.';
      dispatch(voltarParaSelecionarComErro(mensagem));
    } finally {
      setUploadStatus('idle');
    }
  };

  if (!dados.imagemSrc) {
    return (
      <div className={styles.container}>
        <div className={styles.errorContainer}>
          <i className="fas fa-exclamation-triangle"></i>
          <p>Erro: Imagem não encontrada</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.integranteNome}>{dados.integranteNome}</h2>
        <p className={styles.tipoDocumento}>{dados.nomeDocumento}</p>
      </div>

      <div className={styles.previewContainer}>
        {!imageLoaded && (
          <div className={styles.loadingContainer}>
            <i className="fas fa-spinner fa-spin"></i>
            <p>{dados.isPdf ? 'Carregando PDF...' : 'Carregando imagem...'}</p>
          </div>
        )}

        <div style={{ display: imageLoaded ? 'block' : 'none', height: '100%' }}>
          {dados.isPdf ? (
            <PdfInterativo
              src={dados.imagemSrc}
              onLoad={() => setImageLoaded(true)}
              onError={handleImageError}
              onPasswordProtected={handlePasswordProtected}
            />
          ) : (
            <ImagemInterativa
              src={dados.imagemSrc}
              alt={dados.nomeDocumento || 'Documento'}
              onLoad={() => setImageLoaded(true)}
              onError={handleImageError}
            />
          )}
        </div>
      </div>

      <div className={styles.actionContainer}>
        <button
          className={styles.confirmarButton}
          onClick={confirmarInclusao}
          disabled={uploadStatus !== 'idle'}
        >
          <i className={uploadStatus !== 'idle' ? 'fas fa-spinner fa-spin' : 'fas fa-check'}></i>
          {{ idle: 'Confirmar inclusão do documento', enviando: 'Enviando...', salvando: 'Validando documento...' }[uploadStatus]}
        </button>
      </div>
    </div>
  );
};

export default PreviewImagem;
